
import SetFilterItem from "./SetFilterItem";
import classes from './SelectedFiltersDisplay.module.css'
import { useMemo } from "react";
import { useSelector } from "react-redux";
import SetFilterItemMulti from "./SetFilterItemMulti";
import QuickFilters from "./quickFilters/QuickFilters";
import { isMeaningfulWorkQFilterValue } from "../../../lib/filters";

export default function SelectedFiltersDisplayMultiple({filtersValues, workQ, generalAsyncSearchFilter}) {
    const reduxFilters = useSelector(state => state.filter.filters)

    const displayFilters = useMemo(
        () => ({ ...filtersValues, ...reduxFilters }),
        [reduxFilters, filtersValues],
    )

    function isMeaningfulFilterValue(v) {
        return isMeaningfulWorkQFilterValue(v)
    }

    const filtersArray = useMemo(() => {
        if (!displayFilters) {
            return null
        }

        const arr = []
        for (const [key, value] of Object.entries(displayFilters)) {
            if (key == 'case_flags') {
                continue
            }

            if (isMeaningfulFilterValue(value)) {
                if (Array.isArray(value)) {
                    arr.push({
                        key,
                        value,
                        multiple: true,
                    })
                } else {
                    arr.push({
                        key,
                        value,
                        single: true,
                    })
                }
            }
        }

        return arr
    }, [displayFilters])

    const ignoreFilters = ['first_name', 'last_name', 'dob', 'ng_number', 'chart_number', 'search_global', 'search', 'page', 'per_page', 'practice_patient_status_filters_match', ...(workQ?.quick_filters || [])]

    function isIncidentDateMegaFilterValue(value) {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return true
        }
        // Flexible defaults / date-picker values are ISO dates or start|end pipes.
        if (typeof value === 'string') {
            return /^\d{4}-\d{2}-\d{2}(\|\d{4}-\d{2}-\d{2})?$/.test(value)
        }
        return false
    }

    function shouldShowFilterChip(item) {
        if (ignoreFilters.includes(item.key)) {
            return false
        }
        // Search may put free-text incident_date into filters; only show mega-filter values.
        if (item.key === 'incident_date' && !isIncidentDateMegaFilterValue(item.value)) {
            return false
        }
        if (item.key === 'mrq_entry_date' && !isIncidentDateMegaFilterValue(item.value)) {
            return false
        }
        if (item.key === 'gdq_exit_date' && !isIncidentDateMegaFilterValue(item.value)) {
            return false
        }
        // HIPAA / HIOF Option All (null / 'all') is not an active filter chip
        if ((item.key === 'hippa' || item.key === 'hiof_selected') && (item.value === null || item.value === undefined || item.value === '' || item.value === 'all')) {
            return false
        }
        return true
    }

    return <>
        {displayFilters && <div className={classes.filters_wrapper}>
            {Object.values(displayFilters).some(item => isMeaningfulFilterValue(item)) && <div className={classes.container_values}>

            {filtersArray && filtersArray.filter(item => item.single).filter(shouldShowFilterChip).map(item => (
                <SetFilterItem key={item.key+ '_' + (typeof item.value === 'object' ? JSON.stringify(item.value) : item.value)} item={item} workQ={workQ}/>
            ))}

            {filtersArray && filtersArray.filter(item => item.multiple).filter(shouldShowFilterChip).map(item => (
                <SetFilterItemMulti key={`${item.key}_${JSON.stringify(item.value)}`} item={item} filtersValues={displayFilters} workQ={workQ} />
            ))}

            </div>}
        </div>}
        
    
        <QuickFilters quickFilters={workQ?.quick_filters} workQ={workQ} filtersValues={displayFilters} generalAsyncSearchFilter={generalAsyncSearchFilter}/>
    </>
    
}
